import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { TableElement } from 'src/app/www/www-menu/www-menu.component';
import { AccommodationsService } from '../accommodations.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { AccommodationsDataService } from '../accommodations-data.service';

@Component({
	selector: 'app-accommodations-product-without-rooms',
	templateUrl: './accommodations-product-without-rooms.component.html',
	styleUrls: ['./accommodations-product-without-rooms.component.scss'],
})
export class AccommodationsProductWithoutRoomsComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public product,
		public service: AccommodationsService,
		public loader: LoaderService,
		private readonly question: QuestionService,
		private readonly dataService: AccommodationsDataService,
	) {}

	@ViewChild('dataTable') table: MatTable<TableElement>;
	@ViewChild(MatSort) sort: MatSort;

	displayedColumns: string[] = [
		'istourName',
		'businessCaseNumber',
		'status',
		'dateFrom',
		'dateTo',
		'code',
		'countClient',
		'rooms',
		'guarantee',
		'viewGuarantee',
		'edit',
	];
	data: MatTableDataSource<TableElement> = new MatTableDataSource<TableElement>();

	ngOnInit(): void {
		// this.dataService.loadReservationWithOutRoom();
		if (this.product) {
			this.data.data = this.service.data.withoutRooms.filter(
				(obj) => parseInt(obj.bookProductId) == this.product.id,
			);
		} else {
			this.data.data = this.service.data.withoutRooms;
		}
	}

	protected moveStart(reservation): void {
		this.dialogRef.close(true);
		if (!reservation.guarantee) {
			if (reservation.isOfferFromBAG) {
				this.service.startAddingStateToOffer(reservation);
				return;
			}
			this.service.reservationMove = {
				type: 'accommodate',
				reservation: reservation,
			};
			return;
		}
		const question = this.question
			.ask('To jest rezerwacja z gwarancją pokoju. Czy na pewno przenieść?', 'reservationMoveStart')
			.subscribe((result) => {
				if (result.dialogId !== 'reservationMoveStart') {
					return;
				}
				question.unsubscribe();
				if (!result.result) {
					return;
				}
				this.service.reservationMove = {
					type: 'accommodate',
					reservation: reservation,
				};
			});
	}
}
